"use client";

import { useSubmitCommentQuery } from "@/api/AppApi/services/blogs";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import AppToast from "@/app/components/lib/toast/AppToast";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useAtom } from "jotai";
import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface porps {
  blogSlug: string;
  commentID: number | null;
  isReply?: boolean;
  callBack: () => void;
}
const CommentForm: React.FC<porps> = ({
  commentID,
  blogSlug,
  isReply,
  callBack,
}) => {
  const [isUserSignedIn] = useAtom(isSignedInAtom);
  const t = useTranslation();
  const isMobile = useIsMobile();
  const { handleSubmit, control, formState, reset } = useForm();
  const [showToast, setShowToast] = useState(false);
  const [resultMsg, setResultMsg] = useState("");
  const submitComment = useSubmitCommentQuery({
    onSuccess: () => {
      callBack();
      const geustField = { email: "", name: "" };
      reset(isUserSignedIn ? { content: "" } : { ...geustField, content: "" });
    },
    onError: (res) => {
      // console.error("res.message", res);
      setResultMsg(res?.response?.data?.message?.text);
      setShowToast(true);
    },
  });

  const onSubmit = (data: any) => {
    const dataToPost = {
      ...data,
    };
    if (isReply) dataToPost["reply_on"] = commentID;
    submitComment.mutate({ blogSlug, body: { ...dataToPost } });
  };
  const mClass = isMobile ? "-mobile" : "";
  return (
    <>
      {showToast && (
        <AppToast
          delay={7500}
          top
          show={showToast}
          setShow={setShowToast}
          message={<div>{resultMsg}</div>}
        />
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={`comment-form${mClass}`}>
          {!isUserSignedIn && (
            <div className="contact-info">
              <div className="w-100">
                <Controller
                  name="name"
                  control={control}
                  defaultValue=""
                  rules={
                    isUserSignedIn ? {} : { required: t.this_field_is_required }
                  }
                  render={({ field }) => (
                    <input id="name" placeholder={t.your_name} {...field} />
                  )}
                />
                {formState?.errors.name && (
                  <div className="auth-err">
                    {formState?.errors.name.message?.toString()}
                  </div>
                )}
              </div>

              <div className="w-100">
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  rules={{
                    ...(isUserSignedIn
                      ? {}
                      : { required: t.this_field_is_required }),
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: t.invalid_email_address,
                    },
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="email"
                      id="email"
                      placeholder={t.your_ymail_addres}
                    />
                  )}
                />
                {formState?.errors.email && (
                  <div className="auth-err">
                    {formState?.errors?.email?.message?.toString()}
                  </div>
                )}
              </div>
            </div>
          )}
          <div>
            <Controller
              name="content"
              control={control}
              defaultValue=""
              rules={{ required: t.this_field_is_required }}
              render={({ field }) => (
                <input
                  id="comment-field"
                  placeholder={t.write_your_comment_here}
                  className="comment-field"
                  {...field}
                />
              )}
            />
            {formState?.errors.comment && (
              <div className="auth-err">
                {formState?.errors.comment.message?.toString()}
              </div>
            )}
          </div>
          <div className="d-flex justify-content-end">
            <CustomButton
              isSubmit
              type={BtnTypes.primary}
              size={BtnSizes.medium}
              radius={BtnRadius.small}
            >
              {t.send}
            </CustomButton>
          </div>
        </div>
      </form>
    </>
  );
};

export default CommentForm;
